export const SET_FETCH_ACTIVE_TRANSPORTORDERS_TIMEOUT = 'SET_FETCH_ACTIVE_TRANSPORTORDERS_TIMEOUT';
export const SET_FETCH_COMPLETED_TRANSPORTORDERS_TIMEOUT = 'SET_FETCH_COMPLETED_TRANSPORTORDERS_TIMEOUT';
export const SET_FETCH_HIVE_STATE_TIMEOUT = 'SET_FETCH_HIVE_STATE_TIMEOUT';